import { gsap } from "gsap";

export default function() {
  const cloud = gsap.timeline();
  const position = "-=1.7";
  let top01, top02, top03, top04, top05, set01, set02, set03, set04, set05;

  if (window.matchMedia("(min-width: 770px)").matches) {
    top01 = 262;
    top02 = 20;
    top03 = 10;
    top04 = 114;
    top05 = 353;
    set01 = top01 + 20;
    set02 = top02 + 20;
    set03 = top03 + 20;
    set04 = top04 + 20;
    set05 = top05 + 20;

  } else {
    top01 = "30.38vw";
    top02 = "116.5vw";
    top03 = "3.13vw";
    top04 = "31.5vw";
    top05 = "82.95vw";
    set01 = "calc(30.38vw + 20px)";
    set02 = "calc(116.5vw + 20px)";
    set03 = "calc(3.13vw + 20px)";
    set04 = "calc(31.5vw + 20px)";
    set05 = "calc(82.95vw + 20px)";
  }

  gsap.set(".js-fva-cloud01", { top: set01, opacity: 0 });
  gsap.set(".js-fva-cloud02", { top: set02, opacity: 0 });
  gsap.set(".js-fva-cloud03", { top: set03, opacity: 0 });
  gsap.set(".js-fva-cloud04", { top: set04, opacity: 0 });
  gsap.set(".js-fva-cloud05", { top: set05, opacity: 0 });

  cloud.to(".js-fva-cloud01", {
    opacity: 1,
    delay: 1,
    duration: 2,
    top: top01,
    ease: "power4.out"
  });

  cloud.to(
    ".js-fva-cloud02",
    { opacity: 1, duration: 2, top: top02, ease: "power4.out" },
    `${position}`
  );

  cloud.to(
    ".js-fva-cloud03",
    { opacity: 1, duration: 2, top: top03, ease: "power4.out" },
    `${position}`
  );

  cloud.to(
    ".js-fva-cloud04",
    { opacity: 1, duration: 2, top: top04, ease: "power4.out" },
    `${position}`
  );

  cloud.to(
    ".js-fva-cloud05",
    { opacity: 1, duration: 2, top: top05, ease: "power4.out" },
    `${position}`
  );
}
